/**
 * FAQ Navigation
 * Smooth-scroll pills to FAQ sections with active state tracking
 */
(function faqNav() {
  'use strict';

  const SELECTORS = {
    pill: '.faq-nav__pill[data-target]',
    section: '.faq-section',
  };

  const CLASSES = {
    active: 'is-active',
  };

  function getNavbarHeight() {
    const navbar = document.querySelector('.navbar');
    return navbar ? navbar.offsetHeight : 0;
  }

  function setActivePill(targetId) {
    document.querySelectorAll(SELECTORS.pill).forEach(function (pill) {
      pill.classList.toggle(CLASSES.active, pill.dataset.target === targetId);
    });
  }

  function scrollToSection(targetId) {
    var section = document.getElementById(targetId);
    if (!section) return;

    var offset = getNavbarHeight() - 30;
    var top = section.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({ top: top, behavior: 'smooth' });
    setActivePill(targetId);
  }

  function handleScroll() {
    var sections = document.querySelectorAll(SELECTORS.section);
    var navbarHeight = getNavbarHeight() + 40;
    var currentId = null;

    sections.forEach(function (section) {
      var rect = section.getBoundingClientRect();
      if (rect.top <= navbarHeight + 100) {
        currentId = section.id;
      }
    });

    if (currentId) {
      setActivePill(currentId);
    }
  }

  function init() {
    var pills = document.querySelectorAll(SELECTORS.pill);
    if (!pills.length) return;

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        scrollToSection(this.dataset.target);
      });
    });

    // Track scroll for active state
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    });
  }

  document.addEventListener('DOMContentLoaded', init);
})();
